/**
 * Every failure from the API arrives in this shape. `code` is what the client
 * branches on; `message` is for a log, never for a screen, because the copy a
 * user reads has to exist in both locales and the server only speaks one.
 */
export interface ApiErrorBody {
  code: string;
  message: string;
}

export class ApiError extends Error {
  public constructor(
    public readonly status: number,
    public readonly code: string,
    message: string
  ) {
    super(message);
    this.name = 'ApiError';
  }

  /** The upgrade screen opens on this, and only on this. */
  public get isPremiumRequired(): boolean {
    return this.code === 'PREMIUM_REQUIRED';
  }

  public get isUnauthenticated(): boolean {
    return this.status === 401;
  }
}

export interface OkBody {
  ok: true;
}
